import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`CSS variable replacements for SCSS variables`}</h2>
    <p>{`Most legacy SCSS variables from Primer CSS have new CSS variable replacements.`}</p>
    <p>{`For values that have no replacement listed, use the raw value or find a replacement that is close in value.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Legacy `}<inlineCode parentName="th">{`scss`}</inlineCode>{` variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`New `}<inlineCode parentName="th">{`css`}</inlineCode>{` variable`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h00-size-mobile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-display-size`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h0-size-mobile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-title-size-large`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h1-size-mobile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`26px `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h2-size-mobile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`22px `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h3-size-mobile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`18px `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h00-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-48`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h0-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-display-size`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h1-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-title-size-large`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h2-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-24`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h3-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-title-size-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h4-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-title-size-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h5-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-body-size-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$h6-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-body-size-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$font-size-small`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-body-size-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$font-weight-bold`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-text-weight-semibold`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$font-weight-semibold`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-text-weight-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$font-weight-normal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-text-weight-normal`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$font-weight-light`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-text-weight-light`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$lh-condensed-ultra`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$lh-condensed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.25\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$lh-default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.5\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$body-font`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--fontStack-system`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$mono-font`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--fontStack-monospace`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$body-font-size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-body-size-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$body-line-height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--text-body-lineHeight-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-8`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0 `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-4`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-8`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-16`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-24`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-32`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-6`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-40`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-7`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-48`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-64`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-9`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-80`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-10`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-96`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-11`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-112`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$spacer-12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-128`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.0625em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.125em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.25em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.375em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.5em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$em-spacer-6`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.75em `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-16`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0 `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-16`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-20`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-24`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-28`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-32`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-6`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-40`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-7`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-48`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$size-8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--base-size-64`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$container-width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`980px `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$grid-gutter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10px `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$width-xs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0 `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$width-sm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$width-md`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$width-lg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-large`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$width-xl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-xlarge`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$container-sm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$container-md`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$container-lg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-large`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$container-xl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--breakpoint-xlarge`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$viewport-narrow`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--viewportRange-narrow`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$viewport-regular`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--viewportRange-regular`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$viewport-wide`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--viewportRange-wide`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--borderWidth-thin`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`solid `}<inlineCode parentName="td">{`deprecated`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`solid var(--borderWidth-thin) var(--borderColor-default)`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-rem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`solid var(--borderWidth-thin) var(--borderColor-default)`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-radius-1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--borderRadius-small`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-radius-2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--borderRadius-medium`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-radius-3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8px --borderRadius-medium\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$border-radius`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--borderRadius-small`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      